/** The circular-container style builder: a flex-centered square under a full radius. */

import { FLEX_CENTER_STYLE } from '@federa/const/style-flex-presets';
import { borderRadius } from '../css-refs.effects.ts';
import type { CSSProperties } from 'react';

/** Circular container style: flex-centered, equal width/height, full radius; spread and extend with border, cursor, color. */
export function getCircularContainerStyle(size: string, bgColor: string): CSSProperties {
	return {
		...FLEX_CENTER_STYLE,
		width: size,
		height: size,
		borderRadius: borderRadius.full,
		backgroundColor: bgColor,
	};
}
